const nodeEnv = import.meta.env.MODE || "development";

export function ErrorFallback(props) {
  return (
    <div>
      <h2>Oops...</h2>
      <p>
        An unexpected error occurred. Details were logged on the server to help
        in finding the cause. No private information was sent.
      </p>
      {["firox", "development"].includes(nodeEnv) ? (
        <details>
          <summary>Error details</summary>
          <pre>{props.error.toString()}</pre>
          <pre>{props.componentStack}</pre>
        </details>
      ) : null}
    </div>
  );
}
